import { useBasicStore } from '../../../store';
import { useEffect, useState } from 'react';

interface ISetDataToZustand {
  translation: any;
  tourConfigsInput: any;
}

const SetDataToZustand = (props: ISetDataToZustand) => {
  const { translation, tourConfigsInput } = props;
  const [inited, setInited] = useState(false);

  // Only subscribe to the actions, not the state data to avoid render loops
  const setTranslationData = useBasicStore((state) => state.setTranslationData);
  const setTourConfigs = useBasicStore((state) => state.setTourConfigs);

  useEffect(() => {
    if (!inited) {
      if (translation && Object.keys(translation).length > 0) {
        setTranslationData(translation);
        // Get current tourConfigs from store at the time of update
        const currentTourConfigs = useBasicStore.getState().tourConfigs;
        setTourConfigs({ ...currentTourConfigs, ...tourConfigsInput });
        setInited(true);
      }
    }
  }, [translation, setTranslationData, setTourConfigs, tourConfigsInput, inited]);
  return null;
};

export default SetDataToZustand;
